<div class="c-form-field--custom-parameters">
  <div class="c-form-field--custom-parameters--header">
    <div class="c-form-field--custom-parameters--label" i18n="@@common.custom_parameters">Custom Parameters</div>
    <div class="c-form-field--custom-parameters--description" i18n="@@common.custom_parameters_description">
      Pass any data to the advertised page by using dynamic parameters. Their values will be substituted when the lead opens the offer link.
    </div>
  </div>

  @if (editParamId || editParamId === 0) {
  <div class="c-form-field--custom-parameters--main" [formGroup]="paramsFormGroups[editParamId]">
    <div class="c-form-field--custom-parameters--param-header">
      <div class="c-form-field--custom-parameters--param-tag">{{ '{free_' + (editParamId + 1) + '}' }}</div>
      <p500-ui-icon name="bin" size="16px" class="c-button--bin" (click)="removeParameter(editParamId)"></p500-ui-icon>
    </div>
    <p500-ui-text-field formControlName="title" class="align-self-stretch" label="Name" i18n-label="@@common.name"></p500-ui-text-field>
    <div class="c-form-field--custom-parameters--param-settings">
      @for (option of getParamOptionsFormGroups(paramsFormGroups[editParamId]); track option; let j = $index) {
      <div class="c-form-field--custom-parameters--param-setting" [formGroup]="option">
        <div class="c-form-field--custom-parameters--param-setting-radio">
          <gtd-checkbox-with-label
            formControlName="default"
            label="Default"
            i18n-label="@@common.default"
            class="align-self-stretch"
            [showLabel]="j === 0"
            (change)="onCheckboxChange(paramsFormGroups[editParamId], j)"
          ></gtd-checkbox-with-label>
        </div>
        <div class="c-form-field--custom-parameters--param-setting-values">
          @if (j === 0) {
          <p500-ui-text-field formControlName="label" label="Label" i18n-label="@@common.label"></p500-ui-text-field>
          <p500-ui-text-field formControlName="value" label="Value" i18n-label="@@common.value"></p500-ui-text-field>
          <p500-ui-select-field
            formControlName="is_public"
            label="Privacy"
            i18n-label="@@common.privacy"
            [data]="privacyData"
            [disabled]="option.controls['default'].value"
          ></p500-ui-select-field>
          } @else {
          <p500-ui-text-field formControlName="label"></p500-ui-text-field>
          <p500-ui-text-field formControlName="value"></p500-ui-text-field>
          <p500-ui-select-field
            formControlName="is_public"
            [data]="privacyData"
            [disabled]="option.controls['default'].value"
          ></p500-ui-select-field>
          }
        </div>
        <div class="c-form-field--custom-parameters--param-setting-bin">
          <button
            p500-ui-button-icon
            [class.mt-20]="j === 0"
            [disabled]="option.controls['default'].value || getParamOptionsFormGroups(paramsFormGroups[editParamId]).length === 1"
            (click)="removeOption(paramsFormGroups[editParamId], j)"
          >
            <p500-ui-icon name="bin" size="16px" class="c-button--bin"></p500-ui-icon>
          </button>
        </div>
      </div>
      }
      <button
        p500-ui-text-button
        class="c-form-field--custom-parameters--add-option-button"
        (click)="addOption(paramsFormGroups[editParamId])"
        i18n="@@common.plus_add_option"
      >
        + Add Option
      </button>
    </div>
    <div class="c-form-field--custom-parameters--param-buttons">
      <div class="c-form-field--custom-parameters--param-buttons-wrapper">
        <button p500-ui-button i18n="@@common.cancel" (click)="onCancel(paramsFormGroups[editParamId])">Cancel</button>
        <button p500-ui-button [disabled]="paramsFormGroups[editParamId].invalid" (click)="onSave()" i18n="@@common.save">Save</button>
      </div>
    </div>
  </div>
  } @else { @if (paramsFormGroups?.length) {
  <div class="c-form-field--custom-parameters--view-main">
    @for (param of paramsFormGroups; track param; let i = $index) {
    <div class="c-form-field--custom-parameters--view-param-wrapper">
      <div class="c-form-field--custom-parameters--view-param">
        <div class="c-form-field--custom-parameters--view-param-header">
          <div class="c-form-field--custom-parameters--param-tag">{{ '{free_' + (i + 1) + '}' }}</div>
          <div class="c-form-field--custom-parameters--param-name">{{ param.controls['title'].value }}</div>
        </div>
        <div class="c-form-field--custom-parameters--view-param-options">
          @for (option of getParamOptionsFormGroups(param); track option; let j = $index) {
          <div class="c-form-field--custom-parameters--view-param-option">
            @if (option.controls['default'].value) {
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
              <circle cx="4" cy="4" r="4" fill="#0F5EF7" />
            </svg>
            }
            <span class="c-form-field--custom-parameters--view-param-option-label-wrapper">
              <span
                p500UITooltip
                [tooltipData]="option.controls['label'].value"
                class="c-form-field--custom-parameters--view-param-option-label"
                >{{ option.controls['label'].value }}</span
              >:&nbsp;
              <span
                p500UITooltip
                [tooltipData]="option.controls['value'].value"
                class="c-form-field--custom-parameters--view-param-option-value"
                >{{ option.controls['value'].value }}</span
              >
            </span>
            @if (!option.controls['is_public'].value || option.controls['is_public'].value === '0') {
            <p500-ui-icon name="lock" size="12px"></p500-ui-icon>
            }
          </div>
          }
        </div>
      </div>
      <p500-ui-icon name="pencil-underline" size="16px" class="c-button--bin" (click)="editParameter(i)"></p500-ui-icon>
    </div>
    }
  </div>
  } } @if (!paramsFormGroups?.length || (!editParamId && editParamId !== 0)) {
  <button
    p500-ui-text-button
    class="c-form-field--custom-parameters--add-param-button"
    (click)="addParameter()"
    i18n="@@common.plus_add_parameter"
  >
    + Add Parameter
  </button>
  }
</div>
